<template>
  <div>
    <el-table :data="pageData.items" height="480" stripe border :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
      <el-table-column prop="transfer_time" label="变更时间" sortable>
      </el-table-column>
      <el-table-column label="变更前">
        <template slot-scope="scope">
          <ul>
            <li>所属客户: {{scope.row.old_owner_org_name}}</li>
            <li>安装时间: {{scope.row.old_install_time}}</li>
            <li>安装地址: {{scope.row.old_install_address}}</li>
            <li>联系人: {{scope.row.old_contact_name}}</li>
            <li>联系方式: {{scope.row.old_contact_mobile}}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="变更后">
        <template slot-scope="scope">
          <ul>
            <li>所属客户: {{scope.row.new_owner_org_name}}</li>
            <li>安装时间: {{scope.row.new_install_time}}</li>
            <li>安装地址: {{scope.row.new_install_address}}</li>
            <li>联系人: {{scope.row.new_contact_name}}</li>
            <li>联系方式: {{scope.row.new_contact_mobile}}</li>
          </ul>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </div>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    const deviceId = this.deviceId
    return Backend.initListPageNoCache(this, 'device_transfer_recorder', {
      params: {
        device_id: deviceId
      }
    })
  },

  props: ['deviceId'],

  methods: {
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    }
  }
}
</script>
